import { format } from "date-fns";
import { ActionStatisticsDashboardActionType, PatientFilterState, PatientFilterStateActions } from "./types";



export const initialState: PatientFilterState = {
  start_date: format((new Date()).setDate((new Date()).getDate() - 30), "yyyy-MM-dd"),
  end_date: format((new Date()).setDate((new Date()).getDate() + 1), "yyyy-MM-dd"),
  case_id: "",
  global_patient_id: "",
  global_doctor_id: "",
  practice_id: "",
  ref_user:"",
  role:"",
  id:"",
  treatable_page: 1,
  todo_page: 1,
  sp_treatment_page: 1,
  not_treated_page: 1,
  copay_claims_data_page:1,
  drug_id:"",
  section:"coverage_available"
};

export const tableFilterReducer = (state: PatientFilterState, action: ActionStatisticsDashboardActionType): PatientFilterState => {
  switch (action.type) {
    case PatientFilterStateActions.SET_QUERY_PARAMS:
      return {
        ...state,
        ...action.payload,
      };

    case PatientFilterStateActions.SET_REF_USER:
      return {
        ...state,
        ref_user: action.payload,
      };

    case PatientFilterStateActions.CHANGE_TREATABLE_PAGE:
      return {
        ...state,
        treatable_page: action.payload
      };

    case PatientFilterStateActions.CHANGE_TODO_PAGE:
      return {
        ...state,
        todo_page: action.payload,
      };
      case PatientFilterStateActions.CHANGE_COPAY_CLAIM:
      return {
        ...state,
        copay_claims_data_page: action.payload,
      };
    case PatientFilterStateActions.CHANGE_SP_TREATMENT_PAGE:
      return {
        ...state,
        sp_treatment_page: action.payload,
      };

    case PatientFilterStateActions.CHANGE_NOT_TREATED_PAGE:
      return {
        ...state,
        not_treated_page: action.payload,
      };
      case PatientFilterStateActions.CHANGE_USER_ROLE_AND_ID:
      return {
        ...state,
        role: action.payload.role,
        id: action.payload.id,
        ref_user: action.payload.user_ref,
      };

    default:
      return state;
  }
};
